import React, { useState, useContext } from 'react';
import localization from 'assets/localization/localization';
import Images from 'assets/images/imageData';
import CorporateClientForm from 'components/brandActivation/addCorporateClientForm/addCorporateClientForm';
import Layout from 'components/sales/layout/layout';
import { Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import ModalPop from 'components/sales/modal/modal';
import { BaseUrl } from 'contexts/baseUrl/baseUrl';

const AddCorporateClient = ({ postCorpClient, match, history }) => {
  const { baseUrl } = useContext(BaseUrl);
  const [isFiled, setIsFiled] = useState(false);
  const [isModal, setIsModal] = useState(false);
  const [formData, setFormData] = useState({
    company_name: '',
    poc_name: '',
    poc_designation: '',
    poc_email: '',
    poc_contact_no: '',
    employee_count: '',
  });
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async () => {
    if (
      formData.company_name !== '' &&
      formData.poc_designation !== '' &&
      formData.poc_name !== '' &&
      formData.poc_email !== '' &&
      formData.poc_contact_no !== '' &&
      formData.employee_count !== ''
    ) {
      setIsFiled(false);
      setIsLoading(true);
      const res = await postCorpClient({
        ...formData,
        site_id: match?.params?.id,
      });
      if (res) {
        setIsModal(true);
        setFormData({});
      }
      setIsLoading(false);
    } else setIsFiled(true);
  };

  const headerBtns = () => {
    return (
      <Button onClick={handleSubmit} className="btn btn-primary">
        {localization.submitDtl}
        <img src={Images?.ArrowRight} alt="" />
      </Button>
    );
  };

  return (
    <Layout
      title={localization.addCorporateClient}
      Buttons={headerBtns}
      isLoading={isLoading}
      className={isFiled ? 'requiredFileds' : ''}
      isGoback
      linkUrl={`${baseUrl}/brand-activation/corporate-list/${match?.params?.id}`}
    >
      <CorporateClientForm setFormData={setFormData} formData={formData} />

      <ModalPop
        title={localization.conf}
        show={isModal}
        handleModalHide={() => {
          setIsModal(false);
        }}
      >
        <div className="text-center">
          <div className="success">
            <img src={Images?.tick} alt="" />
          </div>
          <h5>{localization.corpClientAddedSuccessfully}</h5>
          <Link
            to={`${baseUrl}/brand-activation/corporate-list/${match.params.id}`}
            className="btn btn-primary mb-4"
          >
            {localization.goToCorporateClientList}{' '}
            <img src={Images?.ArrowRight} alt="" />
          </Link>
        </div>
      </ModalPop>
    </Layout>
  );
};

AddCorporateClient.propTypes = {};

export default AddCorporateClient;
